/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */

import { initReactI18next, useTranslation } from "react-i18next";
import Typography from "@mui/material/Typography";

import ErrorPopup from "../LoaderAndNotification/ErrorPopup";
import Header from "../Layout/Header";
import LoaderPopup from "../LoaderAndNotification/LoaderPopup";
import LottieHelper from "../Layout/LottieHelper";
import PaymentModal from "../Layout/Card/PaymentModal";
import { STEP_MASTER_ENUM } from "../../constants/constant";
import SubHeader from "../Layout/SubHeader";
import SuccessPopup from "../LoaderAndNotification/SuccessPopup";
import creditCardScan from "../../assets/images/CreditCardScan.gif";
import { getModuleConfiguration } from "../../store/Checkin/moduleConfigurationSlice";
import { getSelectedLanguage } from "../../store/Checkin/languageSlice";
import i18n from "i18next";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { getParametersFromLocalStorage } from "../../helpers/commonHelper";
import PriorityBadge from "../Layout/PriorityBadge";
import { GetauthorizationHistory } from "../../network/apiService";

const Payment = ({
  //  isPreauth,
  loading,
  loading2,
  loading3,
  userData,
  erroModalData,
  erroModalData2,
  erroModalData3,
  erroModalData4,
  generateToken,
  closeErrorModal,
  closeErrorModal2,
  closeErrorModal3,
  closeErrorModal4,
  closePreAuthModal,
  paymentToggle,
  setPaymentToggle,
  openModal,
  navigateUrl,
  paymentTypeHandler,
  userCheckIn,
  successLoader,
  successMessage,
  property,
  totalDue,
  onBackPressed,
}) => {
  
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [loading4, setLoading4] = useState(false);
  const token = getParametersFromLocalStorage("token");
  const [showPreAuthModal, setShowPreAuthModal] = useState(false);

  //console.log("Payment component loaded, showpreauthmodal when isPreauth:", isPreauth);
  //const [showPreAuthModal, setShowPreAuthModal] = useState(true);

  const closeModel = () => {
    setShowInfoModal(false);
  };

  const { t } = useTranslation();
  const selectedLanguage = useSelector(getSelectedLanguage);
  const stepMaster = useSelector((state) => getModuleConfiguration(state));
  const paymentPage =
    stepMaster && stepMaster.length > 0
      ? stepMaster.find((ele) => ele.stepCode === STEP_MASTER_ENUM.PAYMENT_PAGE)
      : null;
  const paymentPageCheckout =
    stepMaster && stepMaster.length > 0
      ? stepMaster.find(
          (ele) => ele.stepCode === STEP_MASTER_ENUM.CHECKOUT_PAYMENT_PAGE
        )
      : null;
  const settings = getParametersFromLocalStorage("settings");
  const showPaymentCalculationInfo = settings?.find(
    (setting) =>
      setting.parameterName === "showPaymentCalculationInfo" &&
      setting.parameterValue?.toLowerCase() === "true"
  );
  useEffect(() => {
    const fetchPreauthStatus = async () => {
      const ResNameID = localStorage.getItem("reservationNameID");
      const newObj = {
        ReservationNameID: ResNameID,
      };
      try {
        setLoading4(true);
        const Historyresponse = await GetauthorizationHistory(newObj, token);
        setLoading4(false);

        const isPreauth = Historyresponse?.data?.result ?? false;
        setShowPreAuthModal(isPreauth);

        console.log("**** Preauth Check Result ****", isPreauth);
      } catch (err) {
        console.error("Error fetching preauth status", err);
        setShowPreAuthModal(false);
        setLoading4(false);
      }
    };
    fetchPreauthStatus();
  }, []);

  useEffect(async () => {
    i18n.changeLanguage(selectedLanguage);
  }, []);

  useEffect(() => {
    console.log("showPreAuthModal updated:", showPreAuthModal);
  }, [showPreAuthModal]);
  useEffect(() => {
    if (showPreAuthModal && paymentPageCheckout) {
      console.log("showPreAuthModal is true, paymentPageCheckout exists");
      // Automatically initiate payment
      paymentTypeHandler("creditcard", totalDue, showPreAuthModal);
    }
  }, [showPreAuthModal, paymentPageCheckout]);

  return (
    <div>
      <main>
        {showPreAuthModal && paymentPageCheckout && (
          <Modal
            open={showPreAuthModal}
            onClose={() => setShowPreAuthModal(false)}
            style={{ zIndex: "1" }}
            BackdropProps={{
              style: {
                backgroundColor: "rgba(0, 0, 0, 0.9)",
              },
            }}
          >
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "32%",
                backgroundColor: "#f5f5f5",
                border: "2px #000",
                boxShadow: "0 0 24px rgba(0, 0, 0, 0.5)",
                padding: "50px",
                borderRadius: "20px",
              }}
            >
              <div style={{ textAlign: "center" }}>
                <div>
                  <h5 className="font-weight-600 text-center font-amt">
                    {t("Total Amount Due:")}
                  </h5>
                  <div className="text-center tot-amt font-weight-600 text-center font-amt">
                    <p style={{ marginBottom: "0" }}>
                      {property?.currency}{" "}
                      {parseFloat(totalDue ?? 0).toFixed(2)}{" "}
                    </p>
                  </div>
                  <Typography
                    id="modal-modal-description"
                    sx={{ mt: 2, textAlign: "center", fontSize: "1.2rem" }}
                  >
                    {t(
                      "A pre-authorized amount is available. Processing your final payment..."
                    )}
                  </Typography>
                  <div style={{ textAlign: "center" }}>
                    <div className="lds-ellipsis">
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                </div>

                <div style={{ textAlign: "center", marginTop: "20px" }}>
                  {/* Auto-trigger payment & show loader */}
                  {/* <PreAuthPaymentLoader
                    paymentTypeHandler={paymentTypeHandler}
                    totalDue={totalDue}
                  /> */}
                </div>
              </div>
            </Box>
          </Modal>
        )}
        {/* {showInfoModal && (
          <Modal open={showInfoModal} style={{ zIndex: "1" }}>
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "32%",
                backgroundColor: "#f5f5f5",
                border: "2px #000",
                boxShadow: "0 0 24px rgba(0, 0, 0, 0.5)",
                padding: "50px",
                borderRadius: "20px",
              }}
            >
           
              <button
                id="btn-payment-close"
                className="close-icon"
                onClick={closeModel}
              >
                <CloseIcon
                  onClick={closeModel}
                  style={{ float: "right", margin: "5px", color: "white" }}
                />
              </button>
              <div style={{ textAlign: "center" }}>
                <div>
                  <p>{t("PaymentCalculationInfo")}</p>
                </div>
              
                <div style={{ textAlign: "center", marginTop: "20px" }}>
                  <button
                    id="btn-payment-ok"
                    onClick={closeModel}
                    style={{
                      marginTop: "20px",
                      padding: "15px",
                      marginLeft: "15px",
                    }}
                    className="btn button-blue scan-btn"
                  >
                    {t("OK")}
                  </button>
                </div>
              </div>
            </Box>
          </Modal>
        )} */}
        <SuccessPopup loading={successLoader} successMessage={successMessage} />
        <LoaderPopup loading={loading} />
        <LoaderPopup loading={loading4} />
        {paymentToggle === false && <LoaderPopup loading={loading2} />}

        <ErrorPopup
          erroModalData={erroModalData}
          closeErrorModal={closeErrorModal}
        />
        <ErrorPopup
          erroModalData={erroModalData2}
          closeErrorModal={closeErrorModal2}
        />
        <ErrorPopup
          erroModalData={erroModalData3}
          closeErrorModal={closeErrorModal3}
        />

        <ErrorPopup
          erroModalData={erroModalData4}
          closeErrorModal={closeErrorModal4}
        />

        <div className="main-content">
          <div className="d-flex  h-100 flex-row">
            <div
              style={{
                position: "absolute",
                top: "40px",
                right: "20px",
                zIndex: 10,
              }}
            >
              {/* <PriorityBadge reservationData={reservationData} /> */}
              <PriorityBadge />
            </div>
            <div className="col-5 flex-fill">
              <SubHeader
                onClick={onBackPressed}
                setShowModal={openModal}
                isHome={true}
                title={""}
                subTitle={""}
              />
              <div
                className="justify-content-center"
                style={{ marginTop: "10%" }}
              >
                <div className="p-2">
                  <div className="scan-text">
                    {totalDue > 0 && (
                      <h3 className="text-center font-18 font-weight-700">
                        {/* Make the Payment */}
                        {t("It's time to process your Payment")}
                      </h3>
                    )}
                  </div>
                  <div>
                    <br />
                    <br />
                  </div>

                  {loading ? (
                    <></>
                  ) : (
                    <>
                      <div
                        className="p-2"
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <div
                          className="highlight"
                          style={{ minWidth: "350px" }}
                        >
                          <h5 className="font-weight-600 text-center font-amt">
                            {t("Total Amount Due:")}
                          </h5>

                          <div className="text-center tot-amt font-weight-600 text-center font-amt">
                            <p style={{ marginBottom: "0" }}>
                              {property?.currency}{" "}
                              {parseFloat(totalDue ?? 0).toFixed(2)}{" "}
                            </p>
                          </div>
                        </div>
                      </div>
                      {/* <div className="scan-text">
                        {totalDue > 0 && (
                          <h6 className="text-center font-14 font-weight-100">
                            {t("Please tap Pay and follow the instructions on the")}
                            {t("Payment reader")}
                          </h6>
                        )}
                      </div> */}

                      <div className="scan-text">
                        {totalDue > 0 && (
                          <h6 className="text-center font-14 font-weight-100">
                            {paymentPage &&
                              t(
                                "Please tap Pay and follow the instructions on the Payment reader for check-in"
                              )}
                            {paymentPageCheckout &&
                              t(
                                "Please tap Pay and follow the instructions on the Payment reader for checkout"
                              )}
                          </h6>
                        )}
                      </div>

                      <div className="text-center mt-30">
                        {totalDue ? (
                          <button
                            id="btn-payment-pay"
                            onClick={generateToken}
                            className="btn button-blue proceed-btn pay-btn"
                          >
                            {t("PAY")}
                          </button>
                        ) : (
                          <button
                            id="btn-payment-continue"
                            onClick={userCheckIn}
                            style={{
                              backgroundColor: "#03355c",
                              width: "166px",
                            }}
                            className="btn button-blue proceed-btn"
                          >
                            {t("Continue")}
                          </button>
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="col-7 flex-fill">
              {/* <div className="process-payment-img">
                <img src={creditCardScan} />
              </div> */}
              {paymentPage?.stepImage?.includes(".json") ? (
                <>
                  <LottieHelper animationData="payment_terminal.json" />
                </>
              ) : (
                <>
                  <img
                    src={paymentPage?.stepImage}
                    alt=""
                    style={{ backgroundSize: "cover", width: "100%" }}
                  />
                </>
              )}
              {paymentPageCheckout?.stepImage?.includes(".json") ? (
                <>
                  <LottieHelper animationData="payment_terminal_checkout.json" />
                </>
              ) : (
                <>
                  <img
                    src={paymentPageCheckout?.stepImage}
                    alt=""
                    style={{ backgroundSize: "cover", width: "100%" }}
                  />
                </>
              )}
            </div>
          </div>
        </div>

        {paymentToggle && (
          <PaymentModal
            setPaymentToggle={setPaymentToggle}
            loading2={loading2}
            loading3={loading3}
            erroModalData2={erroModalData2}
            erroModalData3={erroModalData3}
            erroModalData4={erroModalData4}
            closeErrorModal2={closeErrorModal2}
            closeErrorModal3={closeErrorModal3}
            closeErrorModal4={closeErrorModal4}
            paymentTypeHandler={paymentTypeHandler}
            totalAmount={totalDue}
          />
        )}
      </main>
    </div>
  );
};

export default Payment;
